exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-container[data-v-4151db4f] .el-dialog__body{padding:10px 25px 30px}.detail-container .detail-table[data-v-4151db4f]{margin-top:20px;max-height:calc(80vh - 220px);overflow-y:auto}.detail-container .detail-table[data-v-4151db4f] .detail-table-header th{background-color:#f5f7fa;font-size:14px}.detail-container .detail-table .role-edit[data-v-4151db4f]{font-size:16px;margin-left:8px;color:#c0c4cc}.detail-container .detail-table .role-edit[data-v-4151db4f]:hover{color:#409eff;cursor:pointer}\n", ""]);

// exports
